import axios from '@/utils/axios';

export default {
  runOcr(data) {
    return axios.post(`/template/${data.id}/box-detect`, data.box);
  },

  runTemplate(data) {
    return axios.post(`/template/${data.id}/batch`, data.formData);
  },

  getTemplateStatus(data) {
    return axios.get(`/template/${data.id}/batch-status/${data.batch_id}`,);
  },
};